/**
 * Absolute in axios's own sense — including protocol-relative "//host/path",
 * which axios sends cross-host but a naive startsWith("http") check misses.
 * Mirrors axios's isAbsoluteURL helper.
 */
export function isAbsoluteUrl(url: string): boolean {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
